import { Icon } from "@mindlercare/ui-web";
import {
  StyledNavFooter,
  StyledLogoutButton,
  StyledUserId,
} from "./drawer.styles";
import { styled } from "styled-components";
import { Link } from "components/link";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDrawerContext } from "./DrawerContextProvider";
import { useAuth } from "@mindlercare/auth-ui";
import { clearLocalStorage } from "../../helpers/clearLocalStorage";

export const DrawerFooter = () => {
  const { t } = useTranslation();
  const { isDrawerOpen } = useDrawerContext();
  const navigate = useNavigate();
  const { logout, userId } = useAuth();

  const handleLogout = () => {
    logout();
    clearLocalStorage();
    navigate("/login");
  };

  return (
    <StyledNavFooter $isDrawerOpen={isDrawerOpen}>
      {!isDrawerOpen && (
        <StyledLogoutButton
          $isDrawerOpen={isDrawerOpen}
          onClick={handleLogout}
          data-testid="logout-button"
        >
          <Icon.Logout width={20} />
        </StyledLogoutButton>
      )}
      {userId && isDrawerOpen && (
        <>
          <StyledLogoutButton
            onClick={handleLogout}
            $isDrawerOpen={isDrawerOpen}
            data-testid="logout-button"
          >
            {t("LOGOUT")}
          </StyledLogoutButton>
          <StyledUserId variant="body-x-small" color="GRAY">
            {t("USER_ID")}: {userId}
          </StyledUserId>
          <DiscreteLink variant="body-x-small" to="/changelog">
            {"Changelog"}
          </DiscreteLink>
          <DiscreteLink variant="body-x-small" to="/user-settings">
            {t("USER_SETTINGS.DRAWERTITLE")}
          </DiscreteLink>
        </>
      )}
    </StyledNavFooter>
  );
};

const DiscreteLink = styled(Link)`
  color: "GRAY";
  display: block;
`;
